export const staticMondayConfig = {
    "data": {
        "boards": [
            {
                "items_page": {
                    "items": [
                        {
                            "name": "GitLab integration",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline workflows with GitLab integration\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Stay in sync with the monday dev GitLab integration — track merge requests, approvals, and updates in real time, automate workflows, and boost team efficiency without context switching.\",\"changed_at\":\"2025-11-02T09:42:17.253Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "PM solution - Board: backlog, OKRs, customer feedback, Quarterly Goals",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline goals with PM solution: Backlog & OKRs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-09-29T13:08:00.238Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/29866434045970-Product-Team-solution-in-monday-dev\",\"text\":\"https://support.monday.com/hc/en-us/articles/29866434045970-Product-Team-solution-in-monday-dev\",\"changed_at\":\"2025-09-30T14:52:13.411Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Custom Mobile App Experience (powered by Monday Vibe)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance engagement with Custom Mobile App Experience\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Timeline feature, providing clear visibility into project progress and deadlines for all team members.\",\"changed_at\":\"2025-10-27T14:23:21.173Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Create board view with prompt - feedbacks and support release",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance collaboration with prompt feedback boards\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:28:09.704Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#board_view_with_ai\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#board_view_with_ai\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[ESM] [Channels] Shared mailbox Outlook",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[8]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline communication with Shared mailbox Outlook\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly.\",\"changed_at\":\"2025-12-29T14:24:07.518Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[ESM] Customize portal login page content",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[8]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Customize portal login for a personalized experience\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Control login messaging so users see clear guidance, helpful links, and on-brand content from the first touchpoint, reducing confusion and building trust without engineering help.\",\"changed_at\":\"2026-01-29T09:36:25.315Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Admin Content Directory: Tidy up single actions",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with the Admin Content Directory\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-12-29T14:28:20.950Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/4407778410258-Content-directory#Archive_or_delete_content\",\"text\":\"https://support.monday.com/hc/en-us/articles/4407778410258-Content-directory#Archive_or_delete_content\",\"changed_at\":\"2026-02-17T15:42:15.335Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Increase dropdown column lables to 1k",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Expand dropdown labels to 1k for better clarity\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Timeline feature, providing clear visibility into project progress and deadlines for all team members.\",\"changed_at\":\"2025-12-29T14:33:35.419Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360004162179-The-Dropdown-Column\",\"text\":\"https://support.monday.com/hc/en-us/articles/360004162179-The-Dropdown-Column\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Export to excel Scheduled export",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:19.992Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Schedule recurring updates with Scheduled board exports\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Keep stakeholders informed without the manual work using Scheduled board exports. Automatically send up-to-date board snapshots on your chosen cadence to save time and scale reporting with confidence.\",\"changed_at\":\"2026-03-15T11:52:16.395Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1773573617/Generator_featured%20images/Whats%20new%20page/defaults/PLATFORM-monday-platform.jpg\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[RevIntel] Prep for meeting",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:31.445Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Prepare faster with Auto AI meeting briefs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Save hours of manual research with AI meeting briefs. Automatically match calendar events to CRM deals and generate AI-powered briefs in one click so reps walk into every meeting ready.\",\"changed_at\":\"2026-03-15T11:52:17.603Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1773573618/Generator_featured%20images/Whats%20new%20page/defaults/CRM-monday-crm.jpg\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Enable Validation rules and required field in CRM replacing CRM conditional status change",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:33.209Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Improve data accuracy with Platform data validation rules\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Standardize inputs with Platform data validation rules. Apply consistent required fields and validation logic across the platform to keep records clean, reliable, and ready for action.\",\"changed_at\":\"2026-03-15T11:52:16.357Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1773573618/Generator_featured%20images/Whats%20new%20page/defaults/CRM-monday-crm.jpg\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI blocks] Support undo for AI actions in activity log",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:34.966Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Reverse changes with Undo for AI automations\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Stay in control with Undo for AI automations. Instantly roll back AI-generated changes from the Activity Log to fix mistakes, reduce risk, and adopt AI with confidence.\",\"changed_at\":\"2026-03-15T11:52:16.282Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1773573617/Generator_featured%20images/Whats%20new%20page/defaults/PLATFORM-monday-platform.jpg\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI blocks] Support extract to number column",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:36.796Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Extract numbers directly with AI number extraction to columns\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Save time on cleanup with AI number extraction to columns. Send clean, validated numeric values straight into Number columns to eliminate manual formatting and keep data accurate\",\"changed_at\":\"2026-03-15T11:52:17.401Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1773573617/Generator_featured%20images/Whats%20new%20page/defaults/PLATFORM-monday-platform.jpg\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday vibe - email integration",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Build apps seamlessly with monday vibe email integration\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Vibe detects when you need an integration, pauses with a clear prompt to connect, then resumes building your app automatically.\",\"changed_at\":\"2026-05-12T11:18:28.370Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "test dana mirror",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Deal comm] import permissions for collaboration",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:39.847Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Empower contributors to import data with Board Permissions\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Board owners can now enable the import data permission for contributors, giving teams the flexibility to bring data into collaborative boards while maintaining full governance control.\",\"changed_at\":\"2026-03-30T13:58:42.184Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/w_1200,h_1040,c_fit/Generator_featured%20images/Whats%20new%20page/defaults/PLATFORM-monday-platform.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI blocks] Extract V2",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"\",\"text\":\"\",\"changed_at\":\"2026-03-08T10:08:00.094Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI Columns] Add AI Columns to top templates",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:45.997Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Start with AI instantly using AI Columns in templates\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Create boards from top templates and get fully functional AI Columns ready to use from day one.\",\"changed_at\":\"2026-03-30T13:58:41.549Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/w_1200,h_1040,c_fit/Generator_featured%20images/Whats%20new%20page/defaults/PLATFORM-monday-platform.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Prompt to project",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[7]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:15:48.112Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Build structured projects instantly with AI-powered project creation\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Transform a simple prompt into a complete project structure with tasks, timelines, and dependencies ready to go.\",\"changed_at\":\"2026-03-30T13:58:41.683Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/w_1200,h_1040,c_fit/Generator_featured%20images/Whats%20new%20page/defaults/WM-monday-work-management.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI Control Center",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Govern AI access org-wide with AI Control Center\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Use AI Control Center to set default AI permissions, view enablement across workspaces, and lock access for compliance and credit control.\",\"changed_at\":\"2026-05-12T12:24:11.065Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005321509-The-Administration-section-on-monday-com#AI_governance\",\"text\":\"https://support.monday.com/hc/en-us/articles/115005321509-The-Administration-section-on-monday-com#AI_governance\",\"changed_at\":\"2026-03-10T14:02:15.793Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Form branding with ai",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Brand your forms instantly with WorkForms AI brand extraction\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enter your website URL and WorkForms AI brand extraction automatically applies your colors, fonts, and logo to create on-brand forms in seconds.\",\"changed_at\":\"2026-05-12T12:32:14.451Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/28135496780562-Design-your-WorkForm#customize_with_ai\",\"text\":\"Design your WorkForm\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[ESM] Tickets collaboration Q4",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[8]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/24058038904594--My-tickets-on-monday-service\",\"text\":\"\\\"My tickets\\\" on monday service\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Data Repository - 1M Leads and 1M Contacts in CRM",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:16:33.914Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Scale your pipeline with Data Repository for CRM\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Store and manage up to 1M Leads and 1M Contacts with Data Repository for CRM.\",\"changed_at\":\"2026-03-30T13:58:42.346Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/w_1200,h_1040,c_fit/Generator_featured%20images/Whats%20new%20page/defaults/PLATFORM-monday-platform.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday vibe - transfer ownership",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Reassign monday vibe apps with ownership transfer\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Transfer monday vibe apps to another user to maintain continuity when team members change roles or leave.\",\"changed_at\":\"2026-03-30T13:58:44.012Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Iterator / Looping",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:16:41.763Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Automate repetitive tasks with Workflow Builder Loops\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Use Workflow Builder Loops to automatically iterate through lists and apply actions to each item without manual intervention.\",\"changed_at\":\"2026-03-30T13:58:41.581Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/w_1200,h_1040,c_fit/Generator_featured%20images/Whats%20new%20page/defaults/PLATFORM-monday-platform.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Forecasting MVP",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2026-05-17T08:16:43.567Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Plan ahead with data-driven predictions using Forecasting\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Manual guesswork is replaced by intelligent predictions. Forecasting analyzes your data patterns to project future trends, helping you make informed decisions and stay ahead of changes.\",\"changed_at\":\"2026-05-17T08:07:10.489Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/w_1200,h_1040,c_fit/Generator_featured%20images/Whats%20new%20page/defaults/CRM-monday-crm.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday vibe - Manual Update Release",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Admin User Impersonation",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360002426980-How-to-manage-users-on-your-account#Admin_impersonation\",\"text\":\"How to manage users on your account\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "2 way sync - Subtasks 2 way sync from Jira DC",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/31311963811218-Jira-Data-Center-Two-way-sync-app\",\"text\":\"Jira Data Center Two-way sync app\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI Workflows home page",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday vibe - chat mode",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/28451758349842-Create-code-free-custom-apps-with-monday-vibe#dicuss_with_vibe\",\"text\":\"Create code-free custom apps with monday vibe\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday vibe - trigger vibe from sidekick",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday vibe - theme selector",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday vibe - Transcribe your prompts",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[LV] groups sorting",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/26334467738898-The-List-View-Widget#organize_your_list_view_widget\",\"text\":\"The List View Widget\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Data] mondayDB 3.0",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1,\"changed_at\":\"2026-05-25T13:06:41.573Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Vibe - create/edit vibe app account permission",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9,\"changed_at\":\"2026-05-25T13:10:51.905Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Vibe - read data from monday ai notetaker",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1,\"changed_at\":\"2026-05-25T13:10:54.731Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Vibe - export data to MS Powerpoint, Word or Excel",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1,\"changed_at\":\"2026-05-25T13:12:13.977Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Vibe - report on board historical data",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1,\"changed_at\":\"2026-05-25T13:12:26.724Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Vibe - read QR Code & Bar Code",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1,\"changed_at\":\"2026-05-25T13:14:06.056Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Service Account MVP",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9,\"changed_at\":\"2026-05-25T13:22:19.233Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Wand - Alpha",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with Wand - Alpha's insights\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-09-29T13:28:18.293Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/11512670770834-Get-started-with-monday-AI#ai_board_suggestions\",\"text\":\"https://support.monday.com/hc/en-us/articles/11512670770834-Get-started-with-monday-AI#ai_board_suggestions\",\"changed_at\":\"2025-11-09T10:11:33.368Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "workcanvas - create canvas as board view",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Visualize projects with workcanvas board view\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-09-29T13:38:35.805Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-09-30T09:31:32.946Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[iOS] mobile Notetaker - Beta",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Capture ideas seamlessly with iOS Notetaker\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly.\",\"changed_at\":\"2025-09-29T13:41:26.514Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[iOS][Android] AI Sidekick on Mobile",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost productivity with AI Sidekick on mobile\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Dashboards, providing real-time insights and streamlined communication for your projects.\",\"changed_at\":\"2025-09-29T13:42:47.225Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Android] Catch up experience",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Stay updated with the Android catch-up experience\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly.\",\"changed_at\":\"2025-09-29T13:43:51.921Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Subitem followups - file column and people column",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance tracking with subitem followups and columns\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:08:42.385Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/22630036771986-WorkForms-question-types#subitems_question\",\"text\":\"https://support.monday.com/hc/en-us/articles/22630036771986-WorkForms-question-types#subitems_question\",\"changed_at\":\"2025-11-12T10:21:20.169Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":11}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Data Repository - 1M Leads and 1M Contacts in CRM",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost CRM efficiency with 1M leads and contacts\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:09:13.650Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Sprint recap chart",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Visualize sprint success with recap charts\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:30:33.699Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20358136752018-Enhance-sprint-planning-with-Agile-Insights\",\"text\":\"https://support.monday.com/hc/en-us/articles/20358136752018-Enhance-sprint-planning-with-Agile-Insights\",\"changed_at\":\"2025-11-09T10:49:18.272Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[LV] Export to Excel",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline data management with Export to Excel\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:33:23.089Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/26334467738898-The-List-View-Widget\",\"text\":\"https://support.monday.com/hc/en-us/articles/26334467738898-The-List-View-Widget\",\"changed_at\":\"2025-12-29T14:01:59.700Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI blocks] support AI columns in 'add column with AI'",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost efficiency with AI blocks for smarter columns\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:34:02.917Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005466609-The-basics-of-columns#add_a_column_with_ai\",\"text\":\"https://support.monday.com/hc/en-us/articles/115005466609-The-basics-of-columns#add_a_column_with_ai\",\"changed_at\":\"2025-12-03T11:19:19.931Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Board Roles",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Empower teams with clear board roles\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Timeline feature, providing clear visual insights into project progress and deadlines for better planning and execution.\",\"changed_at\":\"2025-10-27T14:34:05.795Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1767302441/Generator_featured%20images/Whats%20new%20page/items%20images/Board_Roles.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday Sidekick in workflow builder - Conversational chat",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with monday Sidekick chat\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-11-05T14:24:29.387Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20598895919122-AI-Workflows-features-and-capabilities\",\"text\":\"https://support.monday.com/hc/en-us/articles/20598895919122-AI-Workflows-features-and-capabilities\",\"changed_at\":\"2026-04-26T06:51:28.414Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Granular board notification settings",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":1,\"invalid\":false,\"changed_at\":\"2026-01-01T21:35:13.105Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Customize notifications with granular board settings\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Fine-tune how and when you get notified with detailed board-level settings. Control alerts for specific actions, reduce noise, and stay focused on what matters most.\",\"changed_at\":\"2025-10-27T14:43:17.865Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1767303281/Generator_featured%20images/Whats%20new%20page/items%20images/Granular_board_notification_settings.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001292545-Notifications-explained\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001292545-Notifications-explained\",\"changed_at\":\"2025-10-21T11:09:21.318Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Create item by card",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Create items easily with item cards\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Add new items through an item card instead of scrolling across long boards. Fill in all key details in one place for faster, cleaner task setup.\",\"changed_at\":\"2025-10-27T14:46:57.475Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005319105-The-basics-of-items#Adding_an_item\",\"text\":\"https://support.monday.com/hc/en-us/articles/115005319105-The-basics-of-items#Adding_an_item\",\"changed_at\":\"2025-09-30T10:31:17.857Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[iOS] Dashboard card",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Visualize progress with iOS Dashboard cards\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly.\",\"changed_at\":\"2025-09-29T13:42:48.832Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Workflow Builder] New action: Get Latest Update",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Get latest updates with Workflow Builder\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:19:30.069Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1767304063/Generator_featured%20images/Whats%20new%20page/items%20images/_New_action__Create_solution_from_template.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Workflow Builder] New Trigger block: When board created",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline workflows with new trigger block\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience enhanced collaboration with the new Task Automation feature, streamlining workflows and saving you valuable time!\",\"changed_at\":\"2025-10-27T14:37:28.210Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1767304162/Generator_featured%20images/Whats%20new%20page/items%20images/New_trigger_block__When_board_created.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Automation builder: New loop detection mechanism",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with automation loop detection\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-11-05T14:24:52.489Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Microsoft 365 Copilot Integration",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Microsoft 365 Copilot Integration\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Provides Copilot with comprehensive access to monday.com features including board management, item operations, dashboards, and more.\",\"changed_at\":\"2025-11-23T14:25:41.396Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Workflow owner persistency",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Ensure clarity with workflow owner persistency\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:37:11.515Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1767303689/Generator_featured%20images/Whats%20new%20page/items%20images/Workflow_owner_persistency.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Multi-branching operator: If People matches",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance decisions with multi-branching operator\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Dashboards, providing real-time insights and streamlined workflows for your projects. Discover how it transforms teamwork!\",\"changed_at\":\"2025-11-05T14:25:36.610Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1767303796/Generator_featured%20images/Whats%20new%20page/items%20images/Multi-branching_-_If_person_matches.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Views management] Hide views (main table)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Hide views for a cleaner main table experience\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Simplify your workspace by hiding unnecessary views. Focus on your main table, reduce clutter, and make navigation faster for you and your team.\",\"changed_at\":\"2025-10-27T14:43:56.897Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#hide_main_table\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#hide_main_table\",\"changed_at\":\"2025-12-01T08:29:53.339Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Workflow builder is released to all Pro tier (with new limit)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with the new Workflow Builder\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:11:14.815Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Stop breaking integration blocks for workflow editor that is not the workflow owner",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with stable integration blocks\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:14:47.928Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1765146163/Generator_featured%20images/Whats%20new%20page/items%20images/Integration_blocks.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Increase # instances per-template to 1,000, and per-account to 5,000",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Scale up with 1,000 instances per template\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Timeline feature, providing clear visibility into project progress and deadlines for all team members.\",\"changed_at\":\"2025-10-27T14:20:46.698Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/18229256953234-Managed-templates-on-monday-com\",\"text\":\"https://support.monday.com/hc/en-us/articles/18229256953234-Managed-templates-on-monday-com\",\"changed_at\":\"2025-12-09T14:10:16.405Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Data Retention - Scheduled Board Deletion policy to Alpha",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline data management with scheduled deletions\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Automatically schedule board deletions to keep your workspace organized and clutter-free. Maintain control over data retention while simplifying cleanup.\",\"changed_at\":\"2025-10-27T14:52:31.546Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Data Retention - Scheduled Board Deletion policy to Alpha",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Manage data effortlessly with scheduled deletions\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Timeline feature, providing clear visibility into project progress and deadlines for seamless teamwork.\",\"changed_at\":\"2025-08-25T13:10:14.164Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Validation rules",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Ensure accuracy with powerful validation rules\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Maintain clean, reliable data with flexible validation rules. Define conditions for column inputs to prevent errors and keep your workflows consistent and accurate.\",\"changed_at\":\"2025-10-27T14:53:32.663Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Validation rules",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Ensure data accuracy with validation rules\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:13:15.643Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Ability to reuse questions - next phase of show/if",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Reuse questions for smarter show/if logic\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly.\",\"changed_at\":\"2025-08-25T13:19:59.200Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/27989721912722-Using-conditional-logic-in-WorkForms#multi-layered_conditional_logic\",\"text\":\"https://support.monday.com/hc/en-us/articles/27989721912722-Using-conditional-logic-in-WorkForms#multi-layered_conditional_logic\",\"changed_at\":\"2025-08-26T13:27:17.862Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Quotes & Invoices - new live editor experience",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance efficiency with Quotes & Invoices live editor\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:26:50.559Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/21050405375762-The-new-Quotes-Invoices\",\"text\":\"https://support.monday.com/hc/en-us/articles/21050405375762-The-new-Quotes-Invoices\",\"changed_at\":\"2025-12-19T00:02:39.183Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Refine text in the text column with AI",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Improve writing quality with AI in the text column\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Refine and polish text directly within the text column using AI. Enhance clarity, tone, and consistency across your boards without leaving your workflow.\",\"changed_at\":\"2025-10-27T14:56:41.800Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/18640208769682-AI-powered-columns#refine_text\",\"text\":\"https://support.monday.com/hc/en-us/articles/18640208769682-AI-powered-columns#refine_text\",\"changed_at\":\"2026-01-14T09:06:54.914Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Workflow agent block - decision making step",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline decisions with the Workflow agent block\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:33:06.356Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Round robin",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with round robin assignments\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:34:30.709Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1757190126/Generator_featured%20images/Whats%20new%20page/items%20images/Round_Robin_assignment.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/29191074306706-Round-robin-automations#h_01K46B1N877T641F3MQSTV4QQ1\",\"text\":\"https://support.monday.com/hc/en-us/articles/29191074306706-Round-robin-automations#h_01K46B1N877T641F3MQSTV4QQ1\",\"changed_at\":\"2025-10-30T11:38:13.991Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Viewing Permission full release (rollover)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance collaboration with viewing permissions\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:36:40.881Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI summarizer V2",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Get concise insights with AI summarizer V2\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:41:12.936Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "SLA management (status column)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[8]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with SLA management insights\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:41:47.587Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/30628237276690-SLA-column-on-monday-service\",\"text\":\"https://support.monday.com/hc/en-us/articles/30628237276690-SLA-column-on-monday-service\",\"changed_at\":\"2025-11-09T08:09:09.797Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI Cleanup suggestions in WS content screen",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance clarity with AI cleanup suggestions\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-08-25T13:47:56.659Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/28869384701586-Workspace-settings-and-customization\",\"text\":\"https://support.monday.com/hc/en-us/articles/28869384701586-Workspace-settings-and-customization\",\"changed_at\":\"2025-12-09T14:13:52.315Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Automated Workflows in Docs: Add Content in WS Docs to Doc Action to GA",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4,28]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with automated workflows in docs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-09-03T11:50:38.758Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/24108289323282-Integrate-workdocs-into-your-workflow#automate_your_workdocs\",\"text\":\"Integrate workdocs into your workflow\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Automated Workflows in Docs: Create Doc Action in WS Docs to GA",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4,28]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with automated workflows in docs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Timeline feature, providing clear visibility on project progress and deadlines for seamless teamwork.\",\"changed_at\":\"2025-09-03T12:08:29.375Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/24108289323282-Integrate-workdocs-into-your-workflow#automate_your_workdocs\",\"text\":\"Integrate workdocs into your workflow\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Smart Assignment with AI in the capacity manager",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[7]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Assign the right people with AI smart assignment\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Save time and plan smarter with AI-powered recommendations in the capacity manager, matching teammates to projects based on skills and availability.\",\"changed_at\":\"2025-07-23T09:33:05.253Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/24114492777618-Resource-management-for-Enterprise\",\"text\":\"https://support.monday.com/hc/en-us/articles/24114492777618-Resource-management-for-Enterprise\",\"changed_at\":\"2025-08-31T16:12:00.253Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Undo - CCV + delete + move",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Easily manage changes with Undo - CCV, delete, move\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly. Click to learn more!\",\"changed_at\":\"2025-07-07T13:41:44.330Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360011810600-How-to-undo-something#undo_via_activity_log\",\"text\":\"https://support.monday.com/hc/en-us/articles/360011810600-How-to-undo-something#undo_via_activity_log\",\"changed_at\":\"2025-09-04T14:15:21.808Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "What's new in the activity log",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance tracking with the new activity log\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T13:42:47.022Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005310745-The-Activity-Log#activity_log_with_ai\",\"text\":\"https://support.monday.com/hc/en-us/articles/115005310745-The-Activity-Log#activity_log_with_ai\",\"changed_at\":\"2025-09-01T13:38:13.773Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "List widget in dashboard",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost clarity with the list widget in dashboards\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Dashboards, providing real-time insights and seamless updates for your projects. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:43:38.305Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/26334467738898-The-List-View-Widget\",\"text\":\"https://support.monday.com/hc/en-us/articles/26334467738898-The-List-View-Widget\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "workcanvas - Create new canvas embedded in monday",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Create new canvases with workcanvas for seamless collaboration\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T13:50:34.779Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-09-30T09:31:12.697Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Text-to-block",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Transform text into actionable blocks\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:08:19.519Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Scale: increased # of instances per-template and per-account",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Scale your productivity with more instances per template\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-28T13:13:50.522Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/18229256953234-Managed-templates-on-monday-com\",\"text\":\"https://support.monday.com/hc/en-us/articles/18229256953234-Managed-templates-on-monday-com\",\"changed_at\":\"2025-12-09T14:08:19.660Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Assign users to departments with SCIM",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline user management with SCIM departments\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:49:58.707Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "New action: Create from template",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[28]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Easily launch projects with create from template\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:54:11.934Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1755112172/Generator_featured%20images/Whats%20new%20page/items%20images/New_action__Create_solution_from_template.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20598895919122-The-workflow-builder-features-and-capabilities#create_from_template\",\"text\":\"https://support.monday.com/hc/en-us/articles/20598895919122-The-workflow-builder-features-and-capabilities#create_from_template\",\"changed_at\":\"2025-11-17T10:45:41.253Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "New multi-branching operator: If group matches",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[28]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with the new multi-branching operator\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:54:45.005Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1756674118/Generator_featured%20images/Whats%20new%20page/items%20images/New_multi-branching_operator__If_group_matches.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI form translations (on submission)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance submissions with AI form translations\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-28T14:00:07.144Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360000358700-Get-started-with-WorkForms\",\"text\":\"https://support.monday.com/hc/en-us/articles/360000358700-Get-started-with-WorkForms\",\"changed_at\":\"2025-10-06T10:03:05.395Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Form builder agent",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost engagement with the Form builder agent\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T14:01:21.870Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/25849257485842-Build-a-WorkForm-with-AI\",\"text\":\"https://support.monday.com/hc/en-us/articles/25849257485842-Build-a-WorkForm-with-AI\",\"changed_at\":\"2025-08-04T11:21:59.120Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday Vibe - monday vibe coding product",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost team spirit with monday Vibe's insights\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T13:27:30.629Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/28451758349842-Create-code-free-custom-apps-with-monday-vibe\",\"text\":\"https://support.monday.com/hc/en-us/articles/28451758349842-Create-code-free-custom-apps-with-monday-vibe\",\"changed_at\":\"2025-07-31T12:04:24.441Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI Everywhere: Doc Inline Editor Entry Points",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance collaboration with AI Everywhere: Doc Inline Editor\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T13:57:55.175Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/24113404490258-Using-AI-in-workdocs\",\"text\":\"https://support.monday.com/hc/en-us/articles/24113404490258-Using-AI-in-workdocs\",\"changed_at\":\"2025-09-04T14:25:19.206Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Linkage - disappearing columns",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance clarity with Linkage - disappearing columns\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:10:13.350Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Sequences] advanced composer capabilities - attachments",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with Sequences attachments\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-08-20T09:39:14.981Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1757192685/Generator_featured%20images/Whats%20new%20page/items%20images/Sequences_analytics_2___300x260.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20666311273874-Sequences\",\"text\":\"Sequences\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Extract from file- smart suggestions",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Risk Detector",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Spot risks early with the Risk Detector\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:54:29.739Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Deals at risk CTA (item level)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Manage risks with Deals at risk CTA\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T13:56:18.575Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Risk Detector",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Spot risks early with the Risk Detector\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:56:24.133Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Subitems] subs of subs- Alpha",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline projects with subs of subs features\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-28T13:17:54.338Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Account hierarchy in CRM",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline management with account hierarchy in CRM\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:24:52.442Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Graphql Aggregation API single board",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline insights with GraphQL Aggregation API\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:36:31.923Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://developer.monday.com/api-reference/reference/aggregate\",\"text\":\"https://developer.monday.com/api-reference/reference/aggregate\",\"changed_at\":\"2025-10-12T12:09:25.958Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Salesforce on New 2 way sync",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance collaboration with Salesforce two-way sync\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:40:34.036Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Jira DC on New 2 way sync",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance collaboration with Jira DC two-way sync\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-28T13:40:42.556Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Conversational AI in the portal",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[8]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Engage effortlessly with Conversational AI\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-28T13:46:04.582Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/19588196914066-monday-service-Customer-Portal\",\"text\":\"monday service Customer Portal\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Add question in minimap + question bank",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance engagement with minimap question bank\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-28T13:59:19.902Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/14124262264978-Build-your-WorkForm#choose_your_question_type\",\"text\":\"https://support.monday.com/hc/en-us/articles/14124262264978-Build-your-WorkForm#choose_your_question_type\",\"changed_at\":\"2025-10-28T10:35:29.885Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Required fields",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Ensure data accuracy with required fields\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-08-18T16:15:16.372Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/27560733058706-Required-columns\",\"text\":\"Required columns\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Listview as subitems widget",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance clarity with Listview as subitems widget\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly.\",\"changed_at\":\"2025-09-29T13:27:15.365Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360017143959-The-Item-Card#available_widget_types\",\"text\":\"https://support.monday.com/hc/en-us/articles/360017143959-The-Item-Card#available_widget_types\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Multi-branching operator: If Dropdown matches",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline decisions with multi-branching operator\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience enhanced collaboration with the new Team Dashboards, providing real-time insights and seamless updates for your projects.\",\"changed_at\":\"2025-10-27T14:17:57.316Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Workflow Builder] New Trigger block: When board created",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline workflows with new trigger block\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience enhanced collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-10-27T14:18:05.949Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Live results (aka \"web-search\") on custom prompt",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Get live results with custom prompts!\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-06-03T15:37:23.254Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/18433811274386-AI-Automation-blocks#web_search_feature\",\"text\":\"AI: Automation blocks\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Wrap text column",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance clarity with the wrap text column\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-06-03T15:38:12.393Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001150345-The-Text-Column\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001150345-The-Text-Column\",\"changed_at\":\"2025-07-01T08:20:28.994Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Data Retention - Scheduled Board Archival to Gradual release",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance efficiency with scheduled board archival\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Click to learn more!\",\"changed_at\":\"2025-06-03T15:41:14.216Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Scheduled board views PDF Exports",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance reporting with scheduled board views exports\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Discover how it transforms your workflow!\",\"changed_at\":\"2025-06-03T15:42:03.666Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#export_your_board_views\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#export_your_board_views\",\"changed_at\":\"2025-06-22T13:02:52.515Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Export board views to PDF",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Export board views to PDF for easy sharing\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Discover seamless project management today!\",\"changed_at\":\"2025-06-03T15:42:05.908Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#export_your_board_views\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#export_your_board_views\",\"changed_at\":\"2025-06-22T13:03:17.140Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Notifications smart priority",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost focus with Notifications smart priority\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-06-03T15:42:06.714Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1754227797/Generator_featured%20images/Whats%20new%20page/items%20images/Notifications_smart_priority.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Export to PDF dashboards",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[18,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Export to PDF Dashboards: Share Insights Easily\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Unlock seamless reporting with 'Export to PDF dashboards'! Effortlessly share your insights and impress stakeholders with professional, customizable PDF reports. Click to learn more!\",\"changed_at\":\"2025-04-08T09:39:05.870Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1754227931/Generator_featured%20images/Whats%20new%20page/items%20images/Export_to_PDF_dashboards.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/26237863849490-Share-and-present-your-Dashboard#schedule_a_pdf_export\",\"text\":\"https://support.monday.com/hc/en-us/articles/26237863849490-Share-and-present-your-Dashboard#schedule_a_pdf_export\",\"changed_at\":\"2025-05-21T08:25:01.945Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Form tags / UTMs",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Track campaigns with lead source tagging\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Effortlessly track campaign sources with our new form tagging feature. Gain valuable insights and optimize your strategies with detailed reporting on each submission.\",\"changed_at\":\"2025-05-20T10:51:32.662Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/11040473466258-WorkForms-settings-and-permissions#form_tags\",\"text\":\"WorkForms settings and permissions\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":11}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Submission view improvements header & show logged in",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Get clarity with submission view improvements\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Know exactly what to expect when filling out a form — see whether you're logged in, if responses are anonymous, how many edits remain, and more, so you can submit with confidence.\",\"changed_at\":\"2025-07-17T06:42:42.831Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Product & Services association to a Deal",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance deals with product-service connections\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Discover how it transforms your workflow!\",\"changed_at\":\"2025-05-06T05:53:30.498Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Revamped form builder - new logic infra + improved form builder performance",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with revamped form builder\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-06-03T15:42:29.645Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "'Admin usage screen' improvements (breakdown by AI action + new empty state)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance admin insights with usage screen upgrades\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-06-03T15:44:10.754Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1750094697/Generator_featured%20images/Whats%20new%20page/items%20images/AI_usage_-_breakdown_by_types.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":11}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI Risk Insights - Top View",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[7]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Spot risks before they strike with AI risk insights\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Identify project risks across your portfolio with AI—analyzing dependencies, due dates, and comments to keep everything on track.\",\"changed_at\":\"2025-07-21T14:07:31.986Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/22551628427666-Portfolio-management-Risk-insights\",\"text\":\"Portfolio management - Risk insights\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Automation Business importance score",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost efficiency with Automation Business importance score\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:15:05.895Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":11}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Duplicate block and paste everywhere",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[28]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T13:24:11.442Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1755111229/Generator_featured%20images/Whats%20new%20page/items%20images/Duplicate_block.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Subitems as input (in \"Custom prompt\")",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with subitems as input\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:29:41.407Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Doc generation with AI",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly. Click to learn more!\",\"changed_at\":\"2025-07-07T13:34:29.996Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday sidekick (Formerly known as AI Sidekick / Expert / Copilot /Assistant)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost productivity with monday AI sidekick\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:35:21.328Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Doc generation with AI",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Generate documents effortlessly with AI\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:35:49.186Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Add column with AI",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance insights with AI-powered column addition\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T13:47:23.002Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005466609-The-basics-of-columns#add_a_column_with_ai\",\"text\":\"https://support.monday.com/hc/en-us/articles/115005466609-The-basics-of-columns#add_a_column_with_ai\",\"changed_at\":\"2025-08-19T09:38:18.849Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Sequence conditional runs",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline workflows with sequence conditional runs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:55:17.965Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1755111728/Generator_featured%20images/Whats%20new%20page/items%20images/Sequences_analytics___300x260.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20666311273874-Sequences\",\"text\":\"https://support.monday.com/hc/en-us/articles/20666311273874-Sequences\",\"changed_at\":\"2025-07-20T13:23:39.866Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Chart order customization",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Customize charts for tailored insights\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-07T14:01:16.152Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001262665-The-Chart-Widget#reoder_your_chart\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001262665-The-Chart-Widget#reoder_your_chart\",\"changed_at\":\"2025-07-09T08:04:55.272Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Detach instance (aka child board) from Managed Template",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Detach instance for flexible project management\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-07-07T13:25:23.516Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Backup & Recovery add-on, powered by Rewind",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Backup & Recovery powered by Rewind\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Safeguard your data with granular control to restore, export, and safeguard your data with full governance oversight.\",\"changed_at\":\"2025-08-05T14:23:22.873Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Exposing \"Not Found\" branch for ALL 4 Find blocks",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[28]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Find clarity with \\\"Not Found\\\" branch visibility\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-07-23T08:34:13.659Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1755111394/Generator_featured%20images/Whats%20new%20page/items%20images/_Not_found__branch.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Updates AI summarizer",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Get concise insights with Updates AI summarizer\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Save time and stay informed with AI-generated summaries of item updates. Quickly grasp what’s important without reading through every comment.\",\"changed_at\":\"2025-05-21T12:55:24.042Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1746951988/Generator_featured%20images/Whats%20new%20page/items%20images/Summarize_updates_threads.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005900249-The-Updates-Section#updates_summary_with_ai\",\"text\":\"https://support.monday.com/hc/en-us/articles/115005900249-The-Updates-Section#updates_summary_with_ai\",\"changed_at\":\"2025-06-30T13:57:16.079Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Improve AI block type selection experience",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance selection with clear AI block types\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects flow smoothly. Discover how to streamline your workflow!\",\"changed_at\":\"2025-05-06T05:51:55.058Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1747058408/Generator_featured%20images/Whats%20new%20page/items%20images/Improve_AI_block_type_selection_experience.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Q2] - Hosted MCP Server",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-07-16T14:30:48.345Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2025-05-18\",\"changed_at\":\"2025-05-21T17:36:40.033Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Connect AI agents and apps to monday.com\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Seamlessly connect AI agents and apps to your account. Once connected, they can manage boards, assign tasks, generate insights, and keep monday.com as your source of truth.\",\"changed_at\":\"2025-07-16T14:30:37.808Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1747830967/Generator_featured%20images/Whats%20new%20page/items%20images/MCP_Release.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://github.com/mondaycom/mcp\",\"text\":\"https://github.com/mondaycom/mcp\",\"changed_at\":\"2025-05-21T06:06:45.523Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-05-21T16:03:55.925Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-05-20T12:13:40.545Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "API for Item Description",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance clarity with API for Item Description\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Use the new API for item description to read and write item descriptions programmatically. Improve visibility and ensure consistent, up-to-date information across systems.\",\"changed_at\":\"2025-05-21T12:58:12.625Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI Dashboard reports - adding images to report (copy)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance AI dashboard reports with images\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Add relevant visuals to your AI-generated dashboard summaries for clearer, more engaging insights. Help teams understand data at a glance.\",\"changed_at\":\"2025-05-21T12:58:57.223Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/26237863849490-Share-and-present-your-Dashboard#create_a_dashboard_report\",\"text\":\"https://support.monday.com/hc/en-us/articles/26237863849490-Share-and-present-your-Dashboard#create_a_dashboard_report\",\"changed_at\":\"2025-06-30T13:52:11.827Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":10}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Calendar can be labeled by date column name",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Label calendars effortlessly by date columns\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Label calendars effortlessly by date columns to bring clarity to your timelines, simplify planning, and manage multiple schedules in one organized view.\",\"changed_at\":\"2025-06-05T12:22:33.940Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Dynamic Home (new home page) - GA",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance productivity with Dynamic Home layout\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Dynamic Home layout surfaces the boards, widgets, and updates that matter most, helping you stay focused, organized, and productive throughout the day.\",\"changed_at\":\"2025-06-05T12:28:30.326Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[TI] Extract attachments to file column - End of February $95K",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[8]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Extract attachments easily to file column\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance ticket management with the Attached Files feature, enabling automatic uploads from emails for seamless access and improved issue resolution.\",\"changed_at\":\"2025-05-11T07:55:03.917Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Revamped form builder",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Create stunning forms with our revamped form builder\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Create forms more easily with a faster, more intuitive form builder. Enjoy smoother logic, better handling of long questions, and effortless question management.\",\"changed_at\":\"2025-06-05T12:29:13.574Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/22630036771986-WorkForms-question-types\",\"text\":\"https://support.monday.com/hc/en-us/articles/22630036771986-WorkForms-question-types\",\"changed_at\":\"2025-05-15T15:15:19.746Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Automations default ownership transfer policy - User offboarding via SCIM",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4,28]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Automatically reassign automations when users are deactivated\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Ensure uninterrupted workflows by auto-transferring ownership when users are deactivated from any source.\",\"changed_at\":\"2025-07-22T14:11:45.081Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://monday.zendesk.com/hc/en-us/articles/25116337794322#default_owner\",\"text\":\"https://monday.zendesk.com/hc/en-us/articles/25116337794322#default_owner\",\"changed_at\":\"2025-07-21T20:41:19.665Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":11}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Batch actions on subs from different parents",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with batch actions on subs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Save time by performing actions on multiple subitems at once. Select subitems across different parent items to quickly duplicate, archive, or delete in bulk.\",\"changed_at\":\"2025-06-05T13:11:10.175Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360011905480-All-about-subitems#moving_subitems_between_items\",\"text\":\"All about subitems\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Listing page: Adding App’s reviews",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost engagement with app reviews\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Discover how it simplifies your workflow!\",\"changed_at\":\"2025-05-06T07:43:50.391Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Account level opt out permission: Allow WS owners to add themselves as board owners",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Allow workspace owners to add themselves as asset owners\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Workspace owners can now add themselves as asset owners to take control of content, simplify organization, and reduce the burden on admins.\",\"changed_at\":\"2025-06-05T13:11:51.959Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360013626380-How-to-keep-your-account-organized\",\"text\":\"How to keep your account organized\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Resource picker - filter by attributes",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[7]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline resource selection with smart filters\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"With the Resource Picker, quickly identify the right people by filtering based on key attributes like skills, location, or role — so you can assign work with confidence and speed.\",\"changed_at\":\"2025-06-30T06:19:40.204Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Capacity manager - group by attribute",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[7]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Optimize planning with Capacity Manager grouping\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Get a high-level view of workload and availability by grouping resources by team, role, or other attributes — making it easier to balance capacity and staff effectively.\",\"changed_at\":\"2025-06-30T06:22:57.331Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/24114492777618-Resource-management-for-Enterprise\",\"text\":\"https://support.monday.com/hc/en-us/articles/24114492777618-Resource-management-for-Enterprise\",\"changed_at\":\"2025-07-08T08:47:54.183Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Design tab",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Elevate teamwork with the new Design tab\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Task Dependencies feature, ensuring your team stays aligned and projects progress smoothly. Discover how it simplifies your workflow!\",\"changed_at\":\"2025-05-06T07:46:07.259Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1747642671/Generator_featured%20images/Whats%20new%20page/items%20images/design_tab.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/28135496780562-Design-your-WorkForm\",\"text\":\"https://support.monday.com/hc/en-us/articles/28135496780562-Design-your-WorkForm\",\"changed_at\":\"2025-07-29T08:07:20.907Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Release actionable outlook notifications",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Get Actionable Outlook Notifications Now!\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Introducing Interactive Email Notifications! Reply to threaded comments and like updates directly from your inbox. Boost collaboration and stay in your workflow effortlessly!\",\"changed_at\":\"2025-04-08T09:58:33.282Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Sprint summary",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Elevate your sprint retros with AI insights\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Get an AI-generated snapshot of key metrics and actionable recommendations to optimize your next sprint. Instantly view info about velocity and unplanned tasks, along with suggestions to improve task estimation and enhance team collaboration.\",\"changed_at\":\"2025-11-03T10:23:54.382Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "detaching Reporting widgets from board structure",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[18,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Speed up insights with fast reporting widgets\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience faster insights with our new reporting widgets that load instantly, delivering complete visualizations without delay.\",\"changed_at\":\"2025-05-13T10:37:43.309Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Hierarchies",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Connect planning to execution with hierarchy view\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"​​Link every roadmap, epic, story, and task to company goals, so leadership always sees how strategy turns into shipping impact.\",\"changed_at\":\"2025-11-03T10:24:21.215Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Friendly item id with Github Pull-Requests",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Easily link GitHub items with friendly item IDs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Reference Monday items in commits, branches, PRs, and issues using friendly or numeric IDs — both automatically link back to your GitUI and GitHub Automations.\",\"changed_at\":\"2025-11-03T10:24:41.896Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Friendly Item Id with Dev template",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Generate scrum boards with friendly item IDs\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Quickly create dev templates from the new modal by entering a team name and friendly item ID — streamlining setup and unlocking full access to the friendly ID feature for all monday dev users.\",\"changed_at\":\"2025-11-03T10:25:32.432Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "MS teams integration",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[21,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost Collaboration with MS Teams Integration!\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Boost collaboration with our MS Teams integration! Seamlessly connect your workflows, enhance communication, and keep your team aligned—all in one place. Discover more!\",\"changed_at\":\"2025-04-08T09:41:36.979Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1751356789/Generator_featured%20images/Whats%20new%20page/items%20images/MS_teams_integration.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001292545-Notifications-explained#receive_notifications_in_ms_teams\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001292545-Notifications-explained#receive_notifications_in_ms_teams\",\"changed_at\":\"2025-08-18T09:36:28.821Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Connectivity of Boards: Mentions or Link to an Existing Board",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[13,4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Link boards seamlessly in docs for better workflow\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance your workflow with board linking in docs. Seamlessly connect unstructured content to actual tasks and data for a holistic view of your projects.\",\"changed_at\":\"2025-04-21T11:16:31.187Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":1}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "CRM <> Mansion integration",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":156,\"post_id\":null,\"changed_at\":\"2025-04-21T13:28:52.321Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Sync virtual event data with your CRM\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Send attendee activity from monday mansion straight to monday CRM, helping your team spot engaged leads and follow up faster.\",\"changed_at\":\"2025-09-09T06:40:27.506Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/26036168782354-monday-CRM-virtual-events#h_01JSHREK4BN1NM97N0Q89QV3VP\",\"text\":\"https://support.monday.com/hc/en-us/articles/26036168782354-monday-CRM-virtual-events#h_01JSHREK4BN1NM97N0Q89QV3VP\",\"changed_at\":\"2025-06-22T15:06:51.264Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":6,\"post_id\":null,\"changed_at\":\"2025-05-14T13:13:31.279Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Summarize updates & threads",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:53:09.601Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1745157565/Summarize_updates___threads.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[monday workflows] - AI Powered workflow generator",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Boost efficiency with AI powered workflow generator\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting productivity effortlessly.\",\"changed_at\":\"2025-11-05T14:25:01.198Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20598895919122-monday-workflows-features-and-capabilities#ai_powered_workflow_generator\",\"text\":\"monday workflows: features and capabilities\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[monday workflows] - Find matching subitem action block",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with matching subitem actions\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enhance collaboration with the new Team Dashboards, providing real-time insights and streamlined workflows for your projects. Discover how it transforms teamwork!\",\"changed_at\":\"2025-11-05T14:25:05.485Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20598895919122-monday-workflows-features-and-capabilities#find_connected_item_find_matching_item_blocks\",\"text\":\"monday workflows: features and capabilities\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[Monday workflows] - Mirror, Dependency & File columns are now supported!",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Enhance workflows with mirror and dependency columns\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience enhanced collaboration with the new Task Automation feature, streamlining workflows and saving you time on repetitive tasks.\",\"changed_at\":\"2025-11-05T14:25:10.815Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[monday workflows] - When any column changes trigger block",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Streamline tasks with monday workflows triggers\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Experience seamless collaboration with the new Task Automation feature, streamlining workflows and boosting team productivity effortlessly.\",\"changed_at\":\"2025-11-05T14:25:24.186Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20598895919122-monday-workflows-features-and-capabilities#when_any_column_changes_trigger_block\",\"text\":\"monday workflows: features and capabilities\",\"changed_at\":null}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":9}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI launch",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-02-20T11:38:52.021Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2025-02-10\",\"changed_at\":\"2025-02-19T11:45:01.600Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"AI Blocks are now open to everyone\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Easily add AI to your workflows with ready-made AI actions and watch smarter work get done, faster.\",\"changed_at\":\"2025-02-20T15:04:04.237Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/fetch/v1740053792/https://res.cloudinary.com/du47ok6rk/image/upload/v1740050588/monday_ai_1_r3jwsv.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://monday.com/w/ai\",\"text\":\"Learn more\",\"changed_at\":\"2025-02-20T11:25:40.826Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-02-19T11:50:09.890Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-02-19T11:45:34.308Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-02-19T11:45:05.615Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2025-02-19T11:45:26.965Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Service out of beta",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[8]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-02-20T11:38:54.511Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2025-02-10\",\"changed_at\":\"2025-02-19T11:50:38.342Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Effortless service excellence is here\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"monday service is officially out of beta. Empower any team to deliver efficient service at scale with powerful AI capabilities.\",\"changed_at\":\"2025-02-20T15:04:36.880Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/fetch/v1740053792/https://res.cloudinary.com/du47ok6rk/image/upload/v1740050580/Service_out_of_beta_rgzzgk.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://monday.com/w/service\",\"text\":\"Learn more\",\"changed_at\":\"2025-02-19T11:49:58.867Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":13,\"post_id\":null,\"changed_at\":\"2025-02-19T11:50:07.469Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-02-19T11:50:33.536Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2025-02-19T11:50:05.163Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Resize Org Chart",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5],\"changed_at\":\"2025-01-08T15:06:25.820Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-02-03T10:25:52.203Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2025-01-27\",\"changed_at\":\"2025-02-03T10:26:01.109Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Resize your org chart effortlessly\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Adapt your organizational chart to fit your layout by resizing nodes and branches. Create polished, scalable visuals that reflect your team’s structure perfectly.\",\"changed_at\":\"2025-01-08T15:16:19.532Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1736684401/WorkCanvas/Resize_org.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/17002448073106-WorkCanvas-Org-Chart-templates\",\"text\":\"https://support.monday.com/hc/en-us/articles/17002448073106-WorkCanvas-Org-Chart-templates\",\"changed_at\":\"2025-01-08T15:06:25.823Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-08T15:15:19.031Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-01-08T15:06:25.822Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-01-08T15:06:25.820Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2025-01-08T15:06:25.822Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Bulk Action with Element Kind Filter",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5],\"changed_at\":\"2025-01-08T15:08:52.943Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-01-12T15:52:34.877Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2025-01-11\",\"changed_at\":\"2025-01-12T15:52:27.268Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Edit multiple elements with one click\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Make bulk changes to all elements of the same type with type-based filters. Quickly update connectors, shapes, or items in just a few clicks, streamlining your canvas editing experience.\",\"changed_at\":\"2025-01-08T15:18:28.011Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1736697081/WorkCanvas/bulk_action_with_element.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/13384193666194-Build-your-WorkCanvas#batch_action_edit\",\"text\":\"Build your WorkCanvas\",\"changed_at\":\"2025-01-12T15:51:57.894Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-08T15:15:19.031Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-01-08T15:08:52.947Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-01-08T15:08:52.942Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2025-01-08T15:08:52.946Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Elbow Connector Breakpoints",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-01-09T10:21:40.221Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2025-01-06\",\"changed_at\":\"2025-01-08T15:00:14.785Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Adjust connector paths with flexible breakpoint\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Gain control over your diagram with adjustable breakpoints for elbow connectors. Shape lines precisely to clarify complex workflows and relationships.\",\"changed_at\":\"2025-01-09T10:31:40.410Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1736417917/WorkCanvas/Elbow_Connector_Break_Points.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/13384193666194-Build-your-WorkCanvas#the_connector_tool\",\"text\":\"Build your WorkCanvas\",\"changed_at\":\"2025-01-12T15:52:12.779Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-08T15:04:06.958Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-01-08T15:00:14.792Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-01-08T15:00:14.787Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2025-01-08T15:00:14.791Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Task Item Updates Action",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:52:04.183Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"AI can now review your tasks’ item updates\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Turn the Updates Section of your items into insights—our AI can now extract key details, produce summaries, and even generate the next steps automatically based on your team’s communications.\",\"changed_at\":\"2025-02-12T09:23:54.400Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Math calculations",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:52:02.950Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Let AI handle your math calculations\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Automate complex calculations ranging from discounts, pricing, and distances with AI—streamlining your processes and reducing errors.\",\"changed_at\":\"2025-02-12T09:27:55.180Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Dashboard Design Improvements",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Reorder views",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI out of beta",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Password protected canvas",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5],\"changed_at\":\"2024-12-25T16:52:43.980Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-12-26T07:51:57.151Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-12-09\",\"changed_at\":\"2024-12-25T16:52:43.979Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Secure your canvas with password protection\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Keep your canvases safe by setting a unique password. Share only with trusted stakeholders for secure collaboration.\",\"changed_at\":\"2024-12-26T11:55:50.444Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1735199208/WorkCanvas/Protected_Password.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/19176857099538-WorkCanvas-sharing-permissions\",\"text\":\"WorkCanvas sharing permissions\",\"changed_at\":\"2024-12-26T10:43:30.646Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:48:19.346Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-12-25T16:52:43.982Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-12-25T16:52:43.980Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-12-25T16:52:43.981Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Hide cursers",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5],\"changed_at\":\"2024-12-25T17:00:18.800Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2025-01-08T14:53:52.741Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-12-23\",\"changed_at\":\"2024-12-26T07:56:15.229Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Manage cursor visibility on your canvas\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Easily hide collaborator cursors on your canvas to reduce visual clutter and stay focused on your tasks.\",\"changed_at\":\"2024-12-25T17:02:53.001Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1736347996/WorkCanvas/Cursors_1.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/13385006792722-Team-collaboration-with-WorkCanvas#vote_on_specific_items\",\"text\":\"Team collaboration with WorkCanvas\",\"changed_at\":\"2024-12-30T12:29:49.098Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:48:19.346Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":0,\"post_id\":null,\"changed_at\":\"2024-12-25T17:00:18.804Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-12-25T17:00:18.799Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-12-25T17:00:18.804Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Conectors arrow heads",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5],\"changed_at\":\"2024-12-25T16:55:56.870Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-12-26T08:00:04.579Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-12-16\",\"changed_at\":\"2024-12-26T07:56:09.436Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Customize connector heads on your canvas\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Adjust arrowheads with customizable styles, sizes, and directions for a clearer, more tailored workflow.\",\"changed_at\":\"2024-12-26T08:08:03.423Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1735199198/WorkCanvas/arrows_heads.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/13384193666194-Build-your-WorkCanvas#the_connector_tool\",\"text\":\"https://support.monday.com/hc/en-us/articles/13384193666194-Build-your-WorkCanvas#the_connector_tool\",\"changed_at\":\"2024-12-30T12:25:11.848Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:48:19.346Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-12-25T16:55:56.872Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-12-25T16:55:56.870Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-12-25T16:55:56.872Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "WorkForms - Randomize, alphabetize or custom order of answer options in forms",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:52:46.802Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Order options the way you want in forms\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Easily alphabetize, randomize, or set a custom order for options in single and multi-select questions. Improve clarity, fairness, and user experience with flexible sorting choices.\",\"changed_at\":\"2025-02-10T16:04:17.444Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/22630036771986-WorkForms-question-types\",\"text\":\"https://support.monday.com/hc/en-us/articles/22630036771986-WorkForms-question-types\",\"changed_at\":\"2025-02-10T16:10:13.385Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-02-10T16:14:27.284Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":0,\"post_id\":null,\"changed_at\":\"2025-02-10T16:14:41.318Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2025-02-10T16:14:32.408Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Sync board permissions with managed (parent) template",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:53:01.255Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Sync board permissions from managed templates\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Update the permission settings of all your instance boards created from one managed template in one go, saving time and ensuring consistency across your team’s boards.\",\"changed_at\":\"2025-02-10T16:47:12.079Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":2,\"post_id\":null,\"changed_at\":\"2025-02-10T16:47:49.638Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Add permissions for users to manage teams they are not the owners of",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:52:50.726Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Grant team management to any account\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Admins can assign team management permissions (add/remove accounts) to any user, even if they’re not a Team Owner or Admin. This helps streamline operations and reduce permissions bloat.\",\"changed_at\":\"2025-02-10T13:32:00.101Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":9,\"post_id\":null,\"changed_at\":\"2025-02-12T09:06:10.134Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":2,\"post_id\":null,\"changed_at\":\"2025-02-10T11:45:42.864Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2025-02-10T11:45:25.083Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Label customization field",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:53:01.255Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"AI categorization upgrade: Label suggestion\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"monday.com's AI can now analyze your dataset and suggest relevant category labels, then automatically sort items into these groups—improving organization and boosting efficiency.\",\"changed_at\":\"2025-02-12T09:21:35.781Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Apply AI on top 100 items in board",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2025-06-08T08:53:01.255Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": "\"Run AI over 200 existing items on your board\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Let AI backfill fields and auto-populate data across up to 200 items at once—saving time and ensuring consistency.\",\"changed_at\":\"2025-02-11T13:16:47.984Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "New favorites",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "mondayDB IOS",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Hidden workspaces",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Feature sunset: daily digest",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Dynamic Values / Macros - Support Standalone/Left-Pane Doc",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Better app subscriptions visibility for upmarket customers",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Announcement Banner",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Support mirror columns",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Monday doc as an input",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Custom AI action to date column and number column",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "[AI] Column setup side panel",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "PDF Export of Docs - WYSIWYG",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":6,\"post_id\":null,\"changed_at\":\"2025-02-17T10:56:38.637Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/8563692121746-Share-and-export-your-workdocs\",\"text\":\"Share and export your workdocs\",\"changed_at\":\"2025-02-12T16:18:06.194Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "PDF Export of Docs - Page Breaks",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":6,\"post_id\":null,\"changed_at\":\"2025-02-17T10:56:35.031Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/8563692121746-Share-and-export-your-workdocs\",\"text\":\"Share and export your workdocs\",\"changed_at\":\"2025-02-12T16:17:52.077Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Sequences",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1],\"changed_at\":\"2024-11-06T16:30:30.472Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-11-15T07:10:49.609Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-11-13\",\"changed_at\":\"2024-11-13T12:46:53.317Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Build an outreach machine with Sequences\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"From lead nurturing to customer follow-up, juggle it all faster without dropping any balls. Drive more engagement with minimal effort by creating sequences with automated emails and task reminders.\",\"changed_at\":\"2024-11-06T16:31:05.653Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1731592460/Generator_featured%20images/Whats%20new%20page/items%20images/Sequences_What_s_new_Product_500x282_2x.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/20666311273874-Sequences-on-monday-CRM\",\"text\":\"https://support.monday.com/hc/en-us/articles/20666311273874-Sequences-on-monday-CRM\",\"changed_at\":\"2024-11-06T16:30:30.475Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":4,\"post_id\":null,\"changed_at\":\"2024-11-06T16:30:30.474Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-11-15T07:35:33.747Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-11-06T16:30:30.474Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Save canvas as template",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5],\"changed_at\":\"2024-11-25T11:38:32.019Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-11-25T11:46:58.823Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-11-06\",\"changed_at\":\"2024-11-25T11:38:32.018Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Save your perfected canvas as a template\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Set templates as private, share them within your team, or generate a link for cross-account access. Streamline recurring workflows and share valuable insights effortlessly across your organization.\",\"changed_at\":\"2024-11-25T11:45:35.465Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1732534835/WorkCanvas/Save_template.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/21566600332178-Create-and-save-templates-on-WorkCanvas\",\"text\":\"https://support.monday.com/hc/en-us/articles/21566600332178-Create-and-save-templates-on-WorkCanvas\",\"changed_at\":\"2024-11-25T11:38:32.023Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-11-25T11:38:32.022Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-11-25T11:38:32.019Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-11-25T11:38:32.022Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Table canvas element",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5],\"changed_at\":\"2024-11-25T11:29:55.874Z\"}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-11-25T11:34:24.372Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-11-18\",\"changed_at\":\"2024-11-25T11:29:55.873Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Organize structured data on your canvas\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Easily create, edit, and format tables directly on your canvas. Add or remove rows and columns, apply cell formatting, and drag-and-drop data or shapes.\",\"changed_at\":\"2024-11-25T11:46:53.598Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://res.cloudinary.com/dupfy9mwu/image/upload/v1732534099/WorkCanvas/Table_element.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/22106086618258-WorkCanvas-table-element\",\"text\":\"https://support.monday.com/hc/en-us/articles/22106086618258-WorkCanvas-table-element\",\"changed_at\":\"2024-11-25T11:29:55.882Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-11-25T11:29:55.877Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-11-25T11:29:55.874Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-11-25T11:29:55.876Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Dashboard - Export to PDF Preview",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "SCIM - sync departments",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Scheduled updates and custom reminders on updates",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Android mondayDB",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "WorkForms new form board view!",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Timeline column revamp",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Sunset of - Performance insights, team updates, news updates and board to globe monday apps",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Sunset of - Collaborative whiteboard app & Org chart app",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Live Collaboration of Users on the Doc",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Doc Version History",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[]}"
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Authentication policies and user-level SSO exclusions",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Brand certified apps in the marketplace",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "New board permissions - move items to another board",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": null
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "New favorites",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-10-31T09:41:00.863Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-10-15\",\"changed_at\":\"2024-10-15T14:06:37.585Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Easy access to your Favorites list\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Enjoy quick and easy access to your Favorites, now conveniently located right above your Workspaces list.\",\"changed_at\":\"2024-10-15T14:06:48.894Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1729001144/Generator_featured%20images/Whats%20new%20page/items%20images/New_favorites_1.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360009142179-The-favorites-section\",\"text\":\"The favorites section\",\"changed_at\":\"2024-10-15T13:50:00.600Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-09-16T08:32:32.112Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-10-15T14:06:08.268Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Test mass email",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-07-03T11:09:06.646Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-07-03\",\"changed_at\":\"2024-07-03T11:04:59.902Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Send tests for your mass email campaigns\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Catch errors and gain confidence that everything in your mass email is exactly right by sending a test email before launching the full campaign.\",\"changed_at\":\"2024-05-12T12:58:49.851Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1720000420/Generator_featured%20images/Whats%20new%20page/items%20images/Test_mass_email_copy.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/10989655392914-Email-campaigns-and-mass-emailing\",\"text\":\"Email campaigns and mass emailing\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": "{\"index\":4,\"post_id\":null,\"changed_at\":\"2024-07-03T11:04:39.275Z\"}"
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[1,2]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-06-20T09:38:31.486Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-07-03T11:04:41.189Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "workcanvas synced templates (to monday)",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-03-25T09:42:12.149Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-03-13\",\"changed_at\":\"2024-03-25T09:41:59.523Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"WorkCanvas synced templates\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"WorkCanvas premade synced templates will automatically create a board on your monday.com account with a logical connection to your canvas. Ensuring an easy and intuitive workflow.\",\"changed_at\":\"2024-03-13T12:41:09.176Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1711359573/Generator_featured%20images/Whats%20new%20page/items%20images/workcanvas_synced_templates_to_monday.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/16760164756242-Integrate-WorkCanvas-with-your-monday-boards#workcanvas_synced_templates\",\"text\":\"Integrate WorkCanvas with your monday boards\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-03-07T12:47:27.523Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-03-25T09:40:26.639Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Burndown filters",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[2]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-04-03T06:56:51.141Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-03-28\",\"changed_at\":\"2024-03-31T09:14:13.387Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"See your monday dev tasks right in VS Code\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Manage tasks and context with the monday VSCode extension—stay in flow while coding and give AI richer context to deliver more accurate, relevant code suggestions.\",\"changed_at\":\"2025-09-11T08:20:05.311Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1712127221/Generator_featured%20images/Whats%20new%20page/items%20images/Burndown_filters.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/17003133339410-The-Burndown-Chart\",\"text\":\"The Burndown Chart\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":11,\"post_id\":null,\"changed_at\":\"2025-02-11T07:29:20.337Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2024-04-08T07:19:08.178Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-03-18T08:24:15.750Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "workcanvas is out of beta",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[5]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-02-01T12:52:48.798Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2024-01-31\",\"changed_at\":\"2024-02-01T12:48:26.442Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Introducing WorkCanvas\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"WorkCanvas is a collaborative digital whiteboard that connects directly to monday.com and allows teams to visually brainstorm, map out, and work together on anything!\",\"changed_at\":\"2024-02-01T12:52:40.925Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1706791895/Generator_featured%20images/Whats%20new%20page/items%20images/workcanvas_is_out_of_beta_2.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/13206630995346\",\"text\":\"Get started with WorkCanvas\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-01-18T14:18:13.198Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2024-02-01T12:49:13.295Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Board discussions",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2024-01-03T10:08:28.380Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-12-29\",\"changed_at\":\"2024-01-03T11:22:58.176Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Communicate across your board with Board Discussions\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Communicating with your team has never been so easy. In addition to the updates section, you can now communicate across your board as a whole using Board Discussions.\",\"changed_at\":\"2023-12-06T08:42:15.673Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1704276333/Generator_featured%20images/Whats%20new%20page/items%20images/Board_discussions.png\""
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-12-06T13:23:11.162Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":2,\"post_id\":null,\"changed_at\":\"2024-01-03T10:08:08.116Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Set response limit on forms",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[6]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-10-24T15:47:12.692Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-10-12\",\"changed_at\":\"2023-10-24T15:43:15.696Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Set a response limit to your WorkForm\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Set a response limit on your WorkForm to cap the amount of responses you receive in order to manage capacity.\",\"changed_at\":\"2023-10-24T15:43:06.119Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1698162406/Generator_featured%20images/Whats%20new%20page/items%20images/Set_response_limit_on_forms.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/11040473466258\",\"text\":\"WorkForms settings and permissions\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2023-10-24T15:47:02.125Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2023-10-24T15:43:50.540Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "View lock permissions",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-09-12T08:06:00.635Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-09-08\",\"changed_at\":\"2023-09-12T08:03:48.254Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Lock your views to prevent unwanted edits\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"You can now lock a customized board view that you created in order to prevent others from changing or editing it!\",\"changed_at\":\"2023-09-12T08:38:42.358Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1694505918/Generator_featured%20images/Whats%20new%20page/items%20images/highlight_View_lock_permissions.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001267945#lock_view\",\"text\":\"The board views\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-08-30T11:40:11.634Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2023-11-14T13:58:27.436Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Date column revamp",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-09-12T07:50:48.805Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-09-04\",\"changed_at\":\"2023-09-12T07:49:59.955Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Date Column revamp\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"The Date Column has been fully reworked with a new date picker that provides a smoother and more accessible data inputting experience.\",\"changed_at\":\"2023-09-12T07:50:40.084Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1694504776/Generator_featured%20images/Whats%20new%20page/items%20images/highlight_Date_column_revamp.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360000317520-The-Date-Column\",\"text\":\"The Date Column\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-09-12T07:50:02.504Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2023-10-17T12:01:06.537Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Dependency types + lead/lag",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[7]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-09-28T18:25:28.796Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-09-24\",\"changed_at\":\"2023-09-28T17:34:05.274Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Advanced dependencies\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Take your project management capabilities up a notch with dependency types, or by adding lead or lag times to define any necessary delays or opportunities to save time.\",\"changed_at\":\"2023-09-28T17:34:03.234Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1695922495/Generator_featured%20images/Whats%20new%20page/items%20images/highlight.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360007402599-Dependencies-on-monday-com#dependency_types\",\"text\":\"Dependencies on monday.com\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":14,\"post_id\":null,\"changed_at\":\"2025-01-05T14:38:29.956Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-09-04T12:39:46.380Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":2,\"post_id\":null,\"changed_at\":\"2023-09-28T13:38:55.845Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Reactions",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-08-08T09:00:29.129Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-08-04\",\"changed_at\":\"2023-08-08T06:09:50.433Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"React to updates with Emojis\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Use Emojis as reactions to updates to better communicate, save time, and for a fun way to express support or celebrate accomplishments.\",\"changed_at\":\"2023-08-10T09:10:24.510Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1691488095/Generator_featured%20images/Whats%20new%20page/items%20images/reactions.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005900249#like_and_reply\",\"text\":\"The Updates Section\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-08-07T12:58:40.998Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2023-08-07T12:46:40.165Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Inbox improvements",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-08-14T08:43:49.843Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-08-02\",\"changed_at\":\"2023-08-08T06:09:36.863Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Introducing the new Update Feed\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Oversee all your updates using the Update Feed! With improved navigation, robust customization options, the option to clear all updates, and more, managing your work has never been easier.\",\"changed_at\":\"2023-08-08T06:05:17.318Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1692002553/Generator_featured%20images/Whats%20new%20page/items%20images/inbox_feed.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/115005309885\",\"text\":\"The Update Feed (Inbox)\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-08-07T12:58:44.740Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2023-08-07T12:46:40.165Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "New monday Layout",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-07-18T08:03:51.759Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-07-13\",\"changed_at\":\"2023-07-13T12:03:27.308Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"monday.com has a new look!\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"We've renovated the monday.com layout to support lots of newly added features, and to make account navigation smoother than ever.\",\"changed_at\":\"2023-08-10T09:10:48.753Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1689671695/Generator_featured%20images/Whats%20new%20page/items%20images/newlayout.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/11398061101714-Introducing-monday-com-s-new-look\",\"text\":\"Introducing monday.com's new look\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-07-13T12:02:45.478Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2023-09-19T11:40:58.163Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "monday AI assistant - task generator",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":2,\"post_id\":null,\"changed_at\":\"2023-08-08T06:12:32.271Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-07-06\",\"changed_at\":\"2023-07-13T12:00:57.644Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Instantly create tasks using monday AI\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Create up to 15 new items at a time according to your specific needs using AI-generated task suggestions.\",\"changed_at\":\"2023-07-13T11:57:49.447Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1689667496/Generator_featured%20images/Whats%20new%20page/items%20images/AI_task_generator_2.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/11512670770834-Get-started-monday-AI\",\"text\":\"Get started: monday AI\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":5,\"post_id\":null,\"changed_at\":\"2023-07-13T12:02:15.167Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":2,\"post_id\":null,\"changed_at\":\"2023-07-13T11:58:32.113Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "AI assistant - formula builder",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[4]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-08-22T14:19:19.267Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-07-23\",\"changed_at\":\"2023-07-23T12:03:13.863Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Build formulas with ease using monday AI\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Create a complex formula in seconds using the new formula AI builder, simply by stating the calculation that you need!\",\"changed_at\":\"2023-07-23T12:03:09.543Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1690118043/Generator_featured%20images/Whats%20new%20page/items%20images/aiassistent.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/360001235445-The-Formula-Column#AI_formula_builder\",\"text\":\"https://support.monday.com/hc/en-us/articles/360001235445-The-Formula-Column#AI_formula_builder\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":15,\"post_id\":null,\"changed_at\":\"2025-01-05T14:49:12.895Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-07-23T12:04:02.384Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":2,\"post_id\":null,\"changed_at\":\"2023-07-19T09:54:20.523Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Live Spreadsheets",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": null
                                },
                                {
                                    "id": "color95",
                                    "value": null
                                },
                                {
                                    "id": "date4",
                                    "value": null
                                },
                                {
                                    "id": "text",
                                    "value": null
                                },
                                {
                                    "id": "short_text",
                                    "value": null
                                },
                                {
                                    "id": "text9",
                                    "value": null
                                },
                                {
                                    "id": "link",
                                    "value": null
                                },
                                {
                                    "id": "team",
                                    "value": null
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": null
                                },
                                {
                                    "id": "color1",
                                    "value": null
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        },
                        {
                            "name": "Mass emails - up to 2000 emails a day",
                            "column_values": [
                                {
                                    "id": "dropdown",
                                    "value": "{\"ids\":[1]}"
                                },
                                {
                                    "id": "color95",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-05-29T09:10:05.688Z\"}"
                                },
                                {
                                    "id": "date4",
                                    "value": "{\"date\":\"2023-05-25\",\"changed_at\":\"2023-05-29T09:09:31.166Z\"}"
                                },
                                {
                                    "id": "text",
                                    "value": "\"Send mass emails in one click\""
                                },
                                {
                                    "id": "short_text",
                                    "value": "{\"text\":\"Distribute thousands of personalized emails in seconds by using the mass emails feature as part of the Emails and Activities app on monday sales CRM.\",\"changed_at\":\"2023-11-07T18:55:15.436Z\"}"
                                },
                                {
                                    "id": "text9",
                                    "value": "\"https://dapulse-res.cloudinary.com/image/upload/v1685266746/Generator_featured%20images/Whats%20new%20page/items%20images/Mass_email_message.png\""
                                },
                                {
                                    "id": "link",
                                    "value": "{\"url\":\"https://support.monday.com/hc/en-us/articles/10989655392914-Email-campaigns-and-mass-emailing\",\"text\":\"Email campaigns and mass emailing\",\"changed_at\":\"2023-05-24T08:17:59.537Z\"}"
                                },
                                {
                                    "id": "team",
                                    "value": "{\"index\":16,\"post_id\":null,\"changed_at\":\"2025-01-05T14:40:50.375Z\"}"
                                },
                                {
                                    "id": "color4",
                                    "value": null
                                },
                                {
                                    "id": "dropdown1",
                                    "value": "{\"ids\":[2,1]}"
                                },
                                {
                                    "id": "color0",
                                    "value": "{\"index\":105,\"post_id\":null,\"changed_at\":\"2023-04-13T12:24:11.941Z\"}"
                                },
                                {
                                    "id": "color1",
                                    "value": "{\"index\":1,\"post_id\":null,\"changed_at\":\"2023-05-30T13:21:06.821Z\"}"
                                },
                                {
                                    "id": "text85",
                                    "value": null
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    }
};
